module.exports = __webpack_public_path__ + "img/t2_ok.f8919989.png";